import { render, staticRenderFns } from "./ProtospellingTable.vue?vue&type=template&id=c51dd1d0&scoped=true&"
import script from "./ProtospellingTable.vue?vue&type=script&lang=js&"
export * from "./ProtospellingTable.vue?vue&type=script&lang=js&"
import style0 from "./ProtospellingTable.vue?vue&type=style&index=0&id=c51dd1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51dd1d0",
  null
  
)

export default component.exports